<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block @click="$router.go(-1)">
          <a-icon type="rollback" />&nbsp; Return
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">
              UM Closed By Authorized
              <small class="m-display-block m-text-small">{{
                data.header[0] ? data.header[0].no_transaksi :""
              }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrintManifest"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="printLoad"
                    >Manifest</a-button
                  >
                </li>
              </ul>
              <a-button icon="more">{{ getScreen ? "" : "Action" }}</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date Created</span>
                  <span class="m-list-desc">{{
                    moment(data.header[0] ? data.header[0].date_created : null, getStandartFormatDate).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{ data.header[0] ?data.header[0].note:"" }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>Bank Name</span>
                  <span class="m-list-desc">{{
                    data.header.nama_bank ? data.header.nama_bank : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Bank Account</span>
                  <span class="m-list-desc">{{
                    data.header.kode_rekening
                  }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>No Cek</span>
                  <span class="m-list-desc">{{ data.header.no_cek }}</span>
                </li> --
                <li v-if="data.header.autodebet_no!='-'">
                  <span class="m-list-title" for>File Support</span>
                  <span class="m-list-desc margin-top">
                    <a-button
                      class="margin-top ant-menu-submenu ant-menu-submenu-selected"
                      icon="download"
                      size="default"
                      @click="handlePreview(data.header.file_support_url)"
                    >View Document</a-button>
                  </span>
                </li> -->
                <li>
                  <span class="m-list-title" for>Total Value</span>
                  <span class="m-list-desc">{{
                    formatCurrency('IDR',Number(data.header[0] ? data.header[0].total_value : 0))
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Terbilang</span>
                  <span class="m-list-desc"
                    ><i>{{data.header[0] ? data.header[0].terbilang : ""
                    }}</i></span
                  >
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse
            class="margin-top margin-bottom"
            activeKey="1"
            v-model="activeKey"
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transaction List</h4>
                <!-- <div v-if="data.file_attachment === null">
                  <a-button
                    @click="editList"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    Edit
                    <a-icon type="edit" />
                  </a-button>
                </div> -->
              </div>
              <a-table
                :rowKey="(record, index) => {return index;}"
                id="transd"
                :columns="columns"
                :dataSource="data.detail"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="uploaded ? { x: 1300 } : { x: 950 }"
              >
                <span slot="value" slot-scope="item">
                  <CurrencyJustified
                    :currencyValue="item.currency"
                    :valueNumber="parseFloat(item.value)"
                  />
                </span>

                <span slot="no" slot-scope="text, record, index">
                  {{index+1}}
                </span>

                <a
                  slot="no_transaksi"
                  slot-scope="item"
                  @click="handleLink(item.transaction_type, item.id_um)"
                  ><b>{{ item.no_um }}</b>
                </a>
                <span slot="createDt" slot-scope="item">
                  {{moment(item.tgl_buat,'YYYY-MM-DD').format(getDefaultDateFormat)}}
                </span>

                <span slot="kurs" slot-scope="item">
                  <CurrencyJustified
                    :currencyValue="item.currency_new"
                    :valueNumber="parseFloat(item.kurs)"
                  />
                </span>

                <span slot="value_kurs" slot-scope="item">
                  <CurrencyJustified
                    :currencyValue="item.currency_new"
                    :valueNumber="parseFloat(item.value_kurs)"
                  />
                </span>
              </a-table>
              <!-- <div v-if="uploaded && jenistransaksi !== 'am'">
                <a-card title="List Cost BKK">
                  <a-table
                    rowKey="id_transaksi"
                    id="transd"
                    :columns="columnsCost"
                    :dataSource="data.cost_list"
                    :pagination="pagination"
                    size="small"
                    bordered
                    :scroll="{ x: 650 }"
                  >
                    <span slot="cost_value" slot-scope="item">
                      <CurrencyJustified
                        :currencyValue="currency"
                        :valueNumber="parseFloat(item.cost_value)"
                      />
                    </span>
                    <template slot="footer">
                      <div class="footer-calc">
                        <a-row :gutter="8">
                          <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                            <span>Total Real Cost Value To IDR</span>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :span="6">
                            <span class="m-text-align m-text-bold">
                              {{ formatCurrencyCode("IDR", totalRealCost) }}
                              <!-- <CurrencyJustified
                                :currencyValue="'IDR'"
                                :valueNumber="
                                  scalegrantotal(totalRealCost, scale, juta)
                                "
                              /> --
                            </span>
                          </a-col>
                        </a-row>
                      </div>
                      <div class="footer-calc">
                        <a-row :gutter="8">
                          <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                            <span>Total Cost Value To IDR</span>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :span="6">
                            <span class="m-text-align m-text-bold">
                              {{ formatCurrencyCode("IDR", totalCost) }}
                              <!-- <CurrencyJustified
                                :currencyValue="'IDR'"
                                :valueNumber="
                                  scalegrantotal(totalCost, scale, juta)
                                "
                              /> --
                            </span>
                          </a-col>
                        </a-row>
                      </div>
                      <div class="footer-calc">
                        <a-row :gutter="8">
                          <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                            <span>Grand Total To IDR</span>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :span="6">
                            <span class="m-text-align m-text-bold">
                              {{
                                formatCurrencyCode(
                                  "IDR",
                                  isRoundingBKKValue=="1" ? Math.ceil(totalRealCost + totalCost) : (totalRealCost + totalCost)
                                )
                              }}
                              <!-- <CurrencyJustified
                                :currencyValue="'IDR'"
                                :valueNumber="
                                  scalegrantotal(
                                    totalRealCost + totalCost,
                                    scale,
                                    juta
                                  )
                                "
                              /> --
                            </span>
                          </a-col>
                        </a-row>
                      </div>
                    </template>
                  </a-table>
                </a-card>
              </div> -->
            </a-collapse-panel>
          </a-collapse>

          <a-card
                  :class="getScreen ? 'margin-bottom margin-top' : 'margin-top'"
                  :loading="pageLoading"
                  v-if="!getScreen && data.jenis === 'Approve'"
          >
            <div slot="title">Manifest actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                        placeholder="Write the note here ... "
                        :rows="4"
                        v-decorator="['catatan_closing']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select
                        showSearch
                        v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                    }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                        @click="handleAction"
                        block
                        :loading="loadingApproval"
                        type="primary"
                        html-type="submit"
                >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="history" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.header[0] ? data.header[0].tlc_create : "" }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(
                          data.header[0] ? data.header[0].date_created : null,
                          getStandartFormatDate
                        ).format(getDefaultDateFormat)
                      }}
                    </h4>
                    <!-- <span
                      class="m-text-small"
                      v-if="data.manifest.catatan"
                    >{{data.manifest.catatan}}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span> -->
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status_app"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Document Support</h4>
              </div>
              <a-list
                itemLayout="horizontal"
                :dataSource="data.document_support"
              >
                <Empty
                  v-if="
                    data.document_support
                      ? data.document_support.length <= 0
                      : data.document_support
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <div slot="description">
                        <span class="m-display-block">{{
                          item.document_name
                        }}</span>

                        <a-button
                          @click="handleViewDoc(item)"
                          class="margin-top"
                          type="dashed"
                          icon="eye"
                          >View Document</a-button
                        >
                      </div>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <!-- <a-modal
      v-model="visibleLampiran"
      @ok="addLampiran"
      :footer="null"
      @cancel="cancelLampiran"
      :width="1000"
    >
      <span slot="title">
        <a-icon type="upload" />&nbsp;Upload Attachment
      </span>

      <a-row class="margin-bottom">
        <a-col>
          <a-table
            v-if="visible_value_bkk"
            rowKey="id_transaksi"
            bordered
            size="small"
            :scroll="{ x: 700, y: 150 }"
            :pagination="false"
            :columns="columnsListData"
            :loading="false"
            :data-source="list_data"
          >
            <a slot="no_transaksi" slot-scope="item"
              >{{ item.no_transaksi }}
            </a>
            <span slot="value" slot-scope="item">
              <CurrencyJustified
                :currencyValue="item.currency"
                :valueNumber="parseFloat(item.value)"
              />
            </span>
            <span slot="valueBayartable" slot-scope="itemn">
              {{ formatRupiah(itemn).replace("Rp", "").replace(",00", "") }}
            </span>
            <div
              slot="actionBayartable"
              style="align: center"
              slot-scope="item"
            >
              <a-popover
                :visible="popoverdtlpendanaan == item.no"
                :key="item.no"
                placement="leftTop"
                trigger="hover"
              >
                <template slot="content">
                  <a-card>
                    <span slot="title">Insert Value Exchange Rate</span>
                    <a-form-item>
                      <a-input-number
                        class="m-width-full m-text-align right"
                        v-model="inputEditvalue"
                        :min="0"
                      />
                    </a-form-item>
                    <a-button-group
                      ghost
                      block
                      class="m-width-full m-text-align right"
                    >
                      <a-button type="primary" @click="simpanEditListData()">
                        Save
                      </a-button>
                      <a-button type="danger" @click="cancelEditListData()">
                        Cancel
                      </a-button>
                    </a-button-group>
                  </a-card>
                </template>
              </a-popover>
              <a-button
                size="small"
                type="primary"
                icon="edit"
                :disabled="item.currency === item.currency_to"
                @click="handleShowValue(item)"
              />
            </div>
            <span slot="value_real" slot-scope="item">
              <CurrencyJustified
                :currencyValue="currency"
                :valueNumber="parseFloat(item.value_real)"
              />
            </span>
          </a-table>
        </a-col>
      </a-row>

      <a-row type="flex" justify="space-between" :gutter="10">
        <a-col :span="24">
          <a-card>
            <a-form :form="formLampiran">
              <a-form-item label="Document Name">
                <a-input
                  autocomplete="off"
                  v-decorator="[
                    'document_name',
                    { rules: [{ required: true }] },
                  ]"
                ></a-input>
              </a-form-item>
              <a-form-item label="Due Date" v-if="this.data.header.no_bg!='-'">
                <a-date-picker
                  placeholder="Select Date"
                  v-decorator="['due_date', { rules: [{ required: true }] }]"
                  format="DD-MM-YYYY"
                  allowClear
                />
              </a-form-item>
              <a-form-item label="Upload Document File">
                <a-upload
                  :showUploadList="true"
                  :beforeUpload="beforeUpload"
                  :remove="handleRemove"
                  v-decorator="[
                    'file_list_lampiran',
                    { rules: [{ required: true }] },
                  ]"
                  :fileList="fileListLampiran"
                >
                  <a-button
                    ref="btndocument"
                    :disabled="fileListLampiran.length > 0"
                    icon="upload"
                    >Select File
                  </a-button>
                </a-upload>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>

      <a-card v-if="visible_value_bkk" title="Cost BKK" class="margin-top">
        <a-row type="flex" justify="space-between" :gutter="10">
          <a-col :span="8">
            <a-form :form="formCost">
              <a-form-item label="Cost Name">
                <a-input
                  v-decorator="['cost_name', { rules: [{ required: true }] }]"
                ></a-input>
              </a-form-item>
              <a-form-item label="Cost Value To IDR">
                <a-input-number
                  type="number"
                  :min="1"
                  class="m-width-full m-text-align-right"
                  v-decorator="['cost_value', { rules: [{ required: true }] }]"
                >
                </a-input-number>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleTambahCostBKK"
                  :loading="tambahLoading"
                  block
                  html-type="submit"
                  >{{
                    this.statusEditCostBKK ? "Update" : "Tambahkan"
                  }}</a-button
                >
              </a-form-item>
            </a-form>
          </a-col>
          <a-col :span="16">
            <a-table
              rowKey="id_transaksi"
              id="transd"
              :columns="columnsCostBKK"
              :dataSource="cost_bkk"
              :pagination="pagination"
              size="small"
              bordered
              :scroll="{ x: 600 }"
            >
              <span slot="cost_value" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="currency"
                  :valueNumber="parseFloat(item.cost_value)"
                />
              </span>
              <div
                slot="actionBayartable"
                style="align: center"
                slot-scope="item"
              >
                <a-button-group size="small">
                  <a-button
                    :disabled="statusEditCostBKK"
                    type="primary"
                    @click="handleEditCostBKK(item)"
                  >
                    <a-icon type="edit" />
                  </a-button>
                  <a-button
                    :disabled="statusEditCostBKK"
                    type="danger"
                    @click="handleRemoveCostBKK(item)"
                  >
                    <a-icon type="close" />
                  </a-button>
                </a-button-group>
              </div>
              <template slot="footer" slot-scope="item">
                <div class="footer-calc">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                      <span>Total Real Cost Value To IDR</span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="6">
                      <span class="m-text-align m-text-bold">
                        {{ formatCurrencyCode("IDR", totalRealCostList) }}
                      </span>
                    </a-col>
                  </a-row>
                </div>
                <div class="footer-calc">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                      <span>Total Cost Value To IDR</span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="6">
                      <span class="m-text-align m-text-bold">
                        {{ formatCurrencyCode("IDR", totalCostBKK) }}
                      </span>
                    </a-col>
                  </a-row>
                </div>
                <div class="footer-calc">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                      <span>Grand Total To IDR</span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="6">
                      <span class="m-text-align m-text-bold">
                        {{
                          formatCurrencyCode(
                            "IDR",
                            isRoundingBKKValue && isRoundingBKKValue=="1" ? Math.ceil(totalRealCostList + totalCostBKK) : (totalRealCostList + totalCostBKK)
                          )
                        }}
                      </span>
                    </a-col>
                  </a-row>
                </div>
              </template>
            </a-table>
          </a-col>
        </a-row>
      </a-card>

      <a-row type="flex" justify="end" :gutter="10" class="margin-top">
        <a-col :span="4">
          <a-button
            type="danger"
            style="float: right; vertical-align: middle"
            @click="handleUploadLampiran"
            :loading="uploadLoading"
          >
            Save
          </a-button>
        </a-col>
      </a-row>
    </a-modal>

    <a-modal
      v-model="editModal"
      :maskClosable="false"
      @cancel="handleClose"
      @ok="handleEditModal"
      :footer="null"
      :width="900"
    >
      <span slot="title">
        <a-icon type="edit" class="margin-right-small" />Edit Transaction
      </span>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
          <a-form-model ref="tlForm" :model="tlForm" :rules="tlRules">
            <a-form-model-item label="Type Number" prop="type">
              <a-radio-group buttonStyle="solid" v-model="tlForm.type" ref="site"
                @change="handlechangegenBKK">
                <a-radio-button type="Radio" value="bilyet_giro" ref="bilyet_giro"
                  >No Billyet Giro</a-radio-button
                >
                <a-radio-button type="Radio" value="no_cek" ref="no_check"
                  >Check Number</a-radio-button
                >
                <a-radio-button type="Radio" value="no_atm" ref="no_atm"
                  >No Atm</a-radio-button
                >
                  <a-radio-button type="Radio" value="auto_debet" ref="auto_debet"
                  >Auto Debet</a-radio-button
                >
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item prop="typeValue">
              <a-input autocomplete="off" v-model="tlForm.typeValue" />
            </a-form-model-item>
            <a-row :gutter="8" v-if="tlForm.type=='auto_debet'">
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-model-item label="Trans Date" prop="trans_date">
                <a-date-picker
                  placeholder="Select Date"
                  v-model="tlForm.trans_date"
                  format="DD-MM-YYYY"
                  allowClear
                />
              </a-form-model-item>
              </a-col>
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-model-item label="Upload File Support" prop="upload">
                  <a-upload
                    :showUploadList="true"
                    :fileList="pushfile"
                    :beforeUpload="beforeUploadFile"
                    :remove="handleRemoveFile"
                    v-model="tlForm.upload"
                  >
                    <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
                  </a-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-form-item label="Rounding Total Value">
              <a-radio-group v-model="isRoundingBKKValue" buttonStyle="solid">
                <a-radio-button type="Radio" value="0">No</a-radio-button>
                <a-radio-button type="Radio" value="1">Yes</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-form-model>
        </a-col>
      </a-row>

      <a-table
        rowKey="key"
        :columns="column_process"
        :dataSource="list_process"
        :pagination="pagination"
        size="small"
        :loading="listProcessLoading"
        bordered
        :scroll="{ x: 1000, y: 500 }"
      >
        <template slot="title">
          <div class="table-header">
            <div>
              <h4 class="margin-remove title">Process List</h4>
              <small>Selected {{ selectedData.length }}</small>
            </div>
            <div class="table-header-extra">
              <a-input-search
                v-model="search"
                placeholder="Input Search Text"
                @change="onChangeSearch"
              />
            </div>
          </div>
        </template>
        <a
          slot="no"
          slot-scope="item"
          @click="handleLink(item.jenis, item.id)"
          >{{ item.no }}</a
        >
        <span slot="value" slot-scope="amount">
          <CurrencyJustified
            v-if="amount.value"
            :currencyValue="amount.currency"
            :valueNumber="amount.value"
          />
          <div v-else style="text-align: center; width: 100%">-</div>
        </span>
        <span slot="update_by" slot-scope="item">
          <span v-if="item.tlc_updated">
            {{ item.tlc_updated }} /
            {{
              item.date_updated
                ? moment(item.date_updated, getDateTimeStandartFormat).format(
                    getDefaultDateFormat
                  )
                : "-"
            }}
          </span>
          <span v-else> - </span>
        </span>
        <span slot="centang" slot-scope="item">
          <a-checkbox
            :default-checked="item.dana_sts"
            :key="item.key"
            @change="changeActionItem(item)"
          />
        </span>
      </a-table>
      <a-row type="flex" justify="end" :gutter="0" class="margin-top">
        <a-col :span="20">
          <a-button
            type="danger"
            style="float: left; vertical-align: middle"
            @click="handleCancelEdit"
            :loading="uploadLoading"
          >
            Cancel
          </a-button>
        </a-col>
        <a-col :span="4">
          <a-button
            style="float: right; vertical-align: middle"
            @click="handleSubmitEdit"
            :loading="submitLoading"
          >
            Submit
          </a-button>
        </a-col>
      </a-row>
    </a-modal> -->

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="history" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.notifikasi" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import moment from "moment";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "ManifestClosingUM",
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (this.pushfile == null) {
        callback(new Error("Upload File Cannot be Empty!"));
      } else {
        callback();
      }
    };
    return {
      data: {
        header: {
          bkk_doc: null,
          bkk_id: "",
          create_dt: "",
          keterangan: "",
          kode_rekening: "",
          nama_bank: "",
          no_bg: "",
          no_bkk: "",
          no_cek: "",
          no_atm: "",
          tlc_create: "",
          total_nilai_terbilang: "",
          value_bkk: "",
          no_transaksi:"",
        },
        file_attachment: [],
        transaction_list: [],
        cost_list: [],
        attachment: [
          {
            file_attachment: null,
            file_attachment_url: null,
            create_dt: null,
            document_name: null,
          }
        ],
      },
      currency: "IDR",
      currencyorigin: "",
      jenistransaksi: undefined,
      pageLoading: false,
      uploadLoading: false,
      tambahLoading: false,
      printLoad: false,
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      visibleLampiran: false,
      fileListLampiran: [],
      visible_value_bkk: false,
      totalRealCost: 0,
      totalCost: 0,
      grandTotal: 0,
      uploaded: false,
      list_data: [],
      popoverdtlpendanaan: undefined,
      inputEditvalue: "",
      inputEditid: {},
      cost_bkk: [],
      statusEditCostBKK: false,
      keyEditCostBKK: {},
      totalRealCostList: 0,
      totalCostBKK: 0,
      widthForm: 600,
      spanCol: 24,
      editModal: false,
      list_process: [],
      selectedData: [],
      search: undefined,
      submitLoading: false,
      listProcessLoading: false,
      activeKey: ["1"],
      tlForm: {},
      tlRules: {
        type: [{ required: true }],
        typeValue: [{ required: true, message: "Type Number Cannot be Empty!" }],
        trans_date: [{ required: true, message: "Trans Date Cannot be Empty!" }],
        upload: [{ required: true,validator: doc_validation,}],
      },
      pushfile:[],
      isRoundingBKKValue: "0",
      doc_validation,
      loadingApproval: false,
      visibleHistory: false,
    };
  },
  beforeCreate() {
    this.formLampiran = this.$form.createForm(this);
    this.formCost = this.$form.createForm(this);
    this.form = this.$form.createForm(this);
  },
  watch: {
    "tlForm.type"() {
      if (this.tlForm.type == "bilyet_giro") {
        this.tlForm.typeValue = this.tlForm.no_bilyet;
      } else if (this.tlForm.type == "no_cek") {
        this.tlForm.typeValue = this.tlForm.no_cek;
      } else{
        this.tlForm.typeValue = this.tlForm.no_atm;
      }
    },
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  mounted() {
    Event.$on("refresh", this.fetchManifest);
    Event.$on("confirmMessageDelete", this.handleRemoveLampiran);
    this.fetchManifest();
    Event.$on("confirmMessageDeleteClear", this.removeCostBKK);
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    //this.fetchData();
  },
  beforeDestroy() {
    Event.$off("refresh", this.fetchManifest);
    Event.$off("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$off("confirmMessageDeleteClear", this.removeCostBKK);
    Event.$off("confirmMessageReturn", this.handleActionProcess);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          align: "right",
          key: "no",
          width: 35,
          scopedSlots: { customRender: "no" },
        },
        {
          title: "No",
          width: 250,
          key: "no_transaksi",
          scopedSlots: { customRender: "no_transaksi" },
          sorter: (a, b) => a.no_transaksi.length - b.no_transaksi.length,
        },
        {
          title: "Create Date",
          width: 150,
          key: "createDt",
          align: "center",
          scopedSlots: { customRender: "createDt" },
          sorter: (a, b) => a.tgl_buat - b.tgl_buat.length,
        },
        {
          title: "Description",
          width: 200,
          key: "description",
          dataIndex: "description",
          sorter: (a, b) => a.description.length - b.description.length,
        },
        {
          title: "Value",
          key: "value",
          width: 200,
          scopedSlots: { customRender: "value" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Transaction Type",
          dataIndex: "transaction_type",
          align: "center",
          key: "label_jenis_transaksi",
          width: 140,
        },
      ];
      // if (this.currencyorigin !== "IDR" && this.jenistransaksi !== "am") {
      //   if (this.data.header.bkk_doc) {
      //     kolom.push(
      //       {
      //         title: "Value Kurs",
      //         key: "kurs",
      //         width: 100,
      //         scopedSlots: { customRender: "kurs" },
      //         sorter: (a, b) => a.quantity.length - b.quantity.length,
      //       },
      //       {
      //         title: "Real Value To IDR",
      //         key: "value_kurs",
      //         width: 100,
      //         scopedSlots: { customRender: "value_kurs" },
      //         sorter: (a, b) => a.quantity.length - b.quantity.length,
      //       }
      //     );
      //   }
      // }
      return kolom;
    },
    columnsCost() {
      const kolom = [
        {
          title: "#",
          dataIndex: "no",
          align: "center",
          key: "no",
          width: 25,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Cost Name",
          width: 200,
          key: "bkk_cost_nm",
          dataIndex: "bkk_cost_nm",
          sorter: (a, b) => a.description.length - b.description.length,
        },
        {
          title: "Value",
          key: "cost_value",
          width: 100,
          scopedSlots: { customRender: "cost_value" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
      ];
      return kolom;
    },
    columnsListData() {
      const kolom = [
        {
          title: "#",
          dataIndex: "no",
          align: "center",
          key: "no",
          width: 40,
        },
        {
          title: "No",
          width: 200,
          key: "no_transaksi",
          scopedSlots: { customRender: "no_transaksi" },
          sorter: (a, b) => a.no_transaksi.length - b.no_transaksi.length,
        },
        {
          title: "Description",
          width: 180,
          key: "description",
          dataIndex: "description",
          sorter: (a, b) => a.description.length - b.description.length,
        },
        {
          title: "Est Value",
          key: "value",
          width: 200,
          scopedSlots: { customRender: "value" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
        {
          title: "Currency to",
          key: "currto",
          dataIndex: "currency_to",
          width: 130,
          align: "center",
        },
        {
          dataIndex: "value_data",
          key: "value_data",
          title: "Exchange Rate",
          className: "editcell-wrap",
          scopedSlots: { customRender: "valueBayartable" },
          width: 110,
        },
        {
          key: "action",
          title: "Action",
          scopedSlots: { customRender: "actionBayartable" },
          width: 60,
        },
        {
          title: "Real Value To IDR",
          key: "value_real",
          width: 200,
          scopedSlots: { customRender: "value_real" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
      ];
      return kolom;
    },
    columnsCostBKK() {
      const kolom = [
        {
          title: "#",
          dataIndex: "no",
          align: "center",
          key: "no",
          width: 25,
        },
        {
          title: "Cost Name",
          width: 200,
          key: "cost_name",
          dataIndex: "cost_name",
          sorter: (a, b) => a.description.length - b.description.length,
        },
        {
          title: "Value",
          key: "cost_value",
          width: 100,
          scopedSlots: { customRender: "cost_value" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
        {
          key: "action",
          title: "Action",
          scopedSlots: { customRender: "actionBayartable" },
          width: 80,
        },
      ];
      return kolom;
    },
    column_process() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: 40,
          align: "center",
        },
        {
          title: "No",
          width: 150,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: 150,
        },

        {
          title: "Value",
          key: "value",
          width: 150,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Update By",
          key: "update_by",
          width: 100,
          align: "center",
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "Generate",
          key: "centang",
          width: 50,
          align: "center",
          scopedSlots: { customRender: "centang" },
        },
      ];
      return kolom;
    },
    file_attachment_dt(){
      let result = null;
      if(this.data.attachment[0].file_attachment){
        let arratc = this.data.attachment[0].file_attachment.split("_");
        let lastindex = arratc.length;
        result = moment(arratc[lastindex-2],'YYYYMMDD').format("YYYY-MM-DD").toString();
      }
      return result;
    }
  },
  methods: {
    moment,
    scalegrantotal(value, scale, jutaan) {
      return scale == "juta"
        ? Math.round(value / jutaan) < 0
          ? 0
          : Math.round(value / jutaan)
        : value;
    },
    cancelEditListData() {
      this.popoverdtlpendanaan = null;
    },
    simpanEditListData() {
      if (this.inputEditvalue == null) {
        this.displayMessage("grather0");
        return;
      }

      this.list_data = this.list_data.map((value, index, arr) => {
        if (value.no === this.inputEditid.no) {
          value.value_data = this.inputEditvalue;
          value.value_real =
            value.currency_to !== "IDR"
              ? this.inputEditvalue / Number(value.value)
              : Number(value.value) * this.inputEditvalue;
        }
        return value;
      });


      this.totalRealCostList = this.list_data.reduce(function (prev, cur) {
        return prev + Number(cur.value_real);
      }, 0);

      this.popoverdtlpendanaan = null;
    },
    handleShowValue(val) {
      this.inputEditvalue = val.value_data;
      this.inputEditid = val;
      this.popoverdtlpendanaan = val.no;
    },
    async fetchManifest() {
      this.pageLoading = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "um_close",
        params: {
          tlc: this.getAuth.username,
          id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = response.data;
          // if (response.data.file_attachment) {
          //   this.data.attachment = [
          //     {
          //       file_attachment: response.data.file_attachment,
          //       file_attachment_url: response.data.file_attachment_url,
          //       create_dt: response.data.header.create_dt,
          //       document_name: response.data.document_name,
          //     },
          //   ];
          // }

          // if (this.data.transaction_list.length > 0) {
          //   this.list_data = this.data.transaction_list.filter((value) => {
          //     return value;
          //   });

          //   if (this.list_data.length > 0) {
          //     for (let index = 0; index < this.list_data.length; index++) {
          //       let col = [
          //         {
          //           ...this.list_data[index],
          //           no: index + 1,
          //           // value_data:
          //           //   this.list_data[index].currency == "IDR"
          //           //     ? parseFloat(this.list_data[index].kurs)
          //           //     : 0,
          //           // value_real:
          //           //   this.list_data[index].currency == "IDR"
          //           //     ? parseFloat(this.list_data[index].value)
          //           //     : 0,
          //           value_data: parseFloat(this.list_data[index].kurs),
          //           value_real: parseFloat(this.list_data[index].value),
          //           currency_to: "IDR",
          //         },
          //       ];
          //       this.list_data[index] = col[0];
          //     }
          //   }

          //   this.currencyorigin = this.data.transaction_list[0].currency;
          //   this.jenistransaksi = this.data.transaction_list[0].jenis_transaksi;
          //   this.visible_value_bkk =
          //     this.data.transaction_list[0].currency == "IDR" ||
          //     this.data.transaction_list[0].jenis_transaksi == "am"
          //       ? false
          //       : true;

          //   if (this.visible_value_bkk) {
          //     this.widthForm =
          //       window.innerWidth - (window.innerWidth * 10) / 100;
          //     this.spanCol = 4;
          //   } else {
          //     this.widthForm = 600;
          //     this.spanCol = 24;
          //   }

          //   for (
          //     let index = 0;
          //     index < this.data.transaction_list.length;
          //     index++
          //   ) {
          //     let col = [
          //       { ...this.data.transaction_list[index], no: index + 1 },
          //     ];
          //     this.data.transaction_list[index] = col[0];
          //   }
          // }

          // this.totalRealCost = this.data.header.sum_transaction_list;
          // if (this.currencyorigin === "IDR") {
          //   this.totalRealCostList = this.totalRealCost;
          // }

          // if (this.data.cost_list.length > 0) {
          //   for (let index = 0; index < this.data.cost_list.length; index++) {
          //     let col = [{ ...this.data.cost_list[index], no: index + 1 }];
          //     this.data.cost_list[index] = col[0];
          //   }
          // }

          // this.totalCost = this.data.header.sum_cost_list;

          // if (this.currencyorigin !== "IDR") {
          //   if (this.data.header.bkk_doc) {
          //     this.uploaded = true;
          //   }
          // }

          // this.isRoundingBKKValue = this.data.header.isrounding;
          // if(this.isRoundingBKKValue=="1"){
          //   this.data.header.value_bkk = Math.ceil(parseFloat(this.data.header.value_bkk));
          // }

          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.data = {};
          this.pageLoading = false;
          this.$router.go(-1);
          return err;
        });
    },
    handleLink(jenis, id_) {
      jenis = jenis.toLowerCase();
      let manifest = "";
      if (jenis == "pi") {
        manifest = "PiManifest";
      } else if (jenis == "umpp") {
        manifest = "UmppManifest";
      } else if (jenis == "umpd") {
        manifest = "umpd_manifest";
      } else if (jenis == "klaimpd") {
        manifest = "manifestKlaimPd";
      } else if (jenis == "klaimpp") {
        manifest = "manifestKlaimPp";
      } else if (jenis == "klaimdirektur") {
        manifest = "manifestDirectur";
      } else if (jenis == "po") {
        manifest = "PoManifest";
      } else if (jenis == "wo") {
        manifest = "manifestWO";
      } else if (jenis == "pp") {
        manifest = "manifestPp";
      } else if (jenis == "kas_kecil") {
        manifest = "manifestLaporanKasKecil";
      } else if (jenis == "sppd") {
        manifest = "manifest";
      } else if (jenis == "lk_um_pp") {
        manifest = "lapUmppManifest";
      } else if (jenis == "lk_um_pd") {
        manifest = "manifestLaporanUmpd";
      } else if (jenis == "addendum") {
        manifest = "AddendumManifest";
      } else if (jenis == "am") {
        manifest = "AccountMutationManifestKeu";
      } else if (jenis == "financing") {
        manifest = "financing-manifest";
      } else if (jenis == "payment_schedule") {
        manifest = "PaymentScheduleManifestKeu";
      } else if (jenis == "bidbond_request") {
        manifest = "bidBondRequest-manifestKeu";
      } else if (jenis == "bidbond") {
        manifest = "bidBond-manifestKeu";
      } else if (jenis == "other_outcome") {
        manifest = "OtherOutcomeManifestKeu";
      } else {
        manifest = "Manifest";
      }
      this.$router.push({ name: manifest, params: { id: id_ } });
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;

      if (this.jenistransaksi !== 'am' && this.currencyorigin !== 'IDR'){
        this.totalRealCostList = 0;
        this.totalCost = 0;
        this.totalCostBKK = 0;
        this.cost_bkk= [];
        for (let index = 0; index < this.list_data.length; index++) {
          this.list_data[index].value_data = 0;
          this.list_data[index].value_real = 0;
        }
      }
    },
    handleDownload(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleRemoveExisting(id) {
      this.confirmMessageValue("confirm-delete", id);
    },
    removeCostBKK(val) {
      this.cost_bkk.splice(
        this.cost_bkk.findIndex((v) => v.no === val.no),
        1
      );
      this.cost_bkk = this.cost_bkk.map((values, index) => {
        values.no = index + 1;
        return values;
      });

      this.totalCostBKK = this.cost_bkk.reduce(function (prev, cur) {
        return prev + Number(cur.cost_value);
      }, 0);

      this.displayMessage("success-del");
    },
    handleRemoveLampiran(item) {
      this.pageLoading = true;
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      axios({
        method: "delete",
        url: serviceUrl + "bkk/delete_bkk",
        processData: false,
        data: {
          id_bkk: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          this.pageLoading = false;
          Event.$emit("refresh", true);
          if (response.data.message === "Document has been Delete") {
            this.displayMessage("success-del");
          } else {
            let responses = Object.assign({}, response.data);
            this.displayMessageValue("error", responses);
          }
        })
        .catch((err) => {
          this.pageLoading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
    handlePrintManifest() {
      this.printLoad = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "bkk/cetak_bkk",
        responseType: "blob",
        params: {
          id_bkk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          console.log(response);
          this.printLoad = false;
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad = false;
          this.$router.go(-1);
        });
    },
    handleTambahCostBKK() {
      this.formCost.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.statusEditCostBKK) {
          this.cost_bkk = this.cost_bkk.map((items, index) => {
            if (items.no === this.keyEditCostBKK.no) {
              items.cost_name = values.cost_name;
              items.cost_value = values.cost_value;
            }
            return items;
          });
          this.statusEditCostBKK = false;
        } else {
          let cost_object = {
            no: 1,
            cost_name: values.cost_name,
            cost_value: values.cost_value,
          };
          this.cost_bkk.push(cost_object);
          this.cost_bkk = this.cost_bkk.map((values, index) => {
            values.no = index + 1;
            return values;
          });
        }
        this.totalCostBKK = this.cost_bkk.reduce(function (prev, cur) {
          return prev + Number(cur.cost_value);
        }, 0);

        this.formCost.resetFields();
        this.displayMessage("success-save");
      });
    },
    handleEditCostBKK(val) {
      this.formCost.setFieldsValue({ cost_name: val.cost_name });
      this.formCost.setFieldsValue({ cost_value: val.cost_value });
      this.keyEditCostBKK = val;
      this.statusEditCostBKK = true;
    },
    handleRemoveCostBKK(val) {
      this.confirmMessageValue("confirm-delete-clear", val);
    },
    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.fileListLampiran.length == 0){
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_bkk", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("document_name", values.document_name);
        formData.append("document_upload", values.file_list_lampiran.file);

        if(this.data.header.no_bg!=''){
          formData.append("tgl_jatuh_tempo", moment(values.due_date).format("YYYY-MM-DD"));
        }

        if (this.visible_value_bkk) {
          let list_data_validate = this.list_data.filter((value) => {
            if (value.value_data <= 0) {
              return value;
            }
          });

          if (list_data_validate.length > 0) {
            this.displayMessage("value-0");
            return;
          }
        }

        let id_dtl_bkk = "";
        let kurs_dtl_bkk = "";
        let value_dtl_bkk = "";

        if (this.list_data.length > 0) {
          let stoper = this.list_data.length - 1;
          for (let index = 0; index < this.list_data.length; index++) {
            id_dtl_bkk =
              id_dtl_bkk +
              this.list_data[index].bkk_dtl_id +
              (stoper != index ? "," : "");
            kurs_dtl_bkk =
              kurs_dtl_bkk +
              this.list_data[index].value_data +
              (stoper != index ? "," : "");
            console.log(kurs_dtl_bkk)
            value_dtl_bkk =
              value_dtl_bkk +
              this.list_data[index].value_real +
              (stoper != index ? "," : "");
          }
        }

        formData.append("id_dtl_bkk", id_dtl_bkk);
        formData.append("kurs_dtl_bkk", kurs_dtl_bkk);
        formData.append("value_dtl_bkk", value_dtl_bkk);

        let cost_names_bkk = "";
        let cost_values_bkk = "";

        if (this.cost_bkk.length > 0) {
          for (let index = 0; index < this.cost_bkk.length; index++) {
            cost_names_bkk =
              cost_names_bkk +
              this.cost_bkk[index].cost_name +
              (index !== this.cost_bkk.length - 1 ? ";" : "");
            cost_values_bkk =
              cost_values_bkk +
              this.cost_bkk[index].cost_value +
              (index !== this.cost_bkk.length - 1 ? ";" : "");
          }
        }
        formData.append("cost_name_bkk", cost_names_bkk);
        formData.append("cost_value_bkk", cost_values_bkk);
        formData.append("is_rounding", this.isRoundingBKKValue);
        //console.log(kurs_dtl_bkk)
        //console.log(value_dtl_bkk)
        //console.log(cost_names_bkk)
        //console.log(cost_values_bkk)
        this.uploadLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "bkk/upload_bkk",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.uploadLoading = false;
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            this.$router.go(0);
          })
          .catch((err) => {
            this.uploadLoading = false;
            console.log("error : " + err);
          });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileListLampiran.push(file);
        return false;
      }
    },
    beforeUploadFile(file) {
      const FileSize = file.size / 1024 / 1024;
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.pushfile = [file];
          this.tlForm.upload = file;
          return false;
        }
    },
    handleRemoveFile() {
      this.pushfile = null;
      this.$refs.tlForm.upload = null;
    },
    cancelLampiran() {
      this.fileListLampiran = [];
      this.formLampiran.resetFields();
      this.popoverdtlpendanaan = null;
    },
    handleRemove(file) {
      const index = this.fileListLampiran.indexOf(file);
      const newFileList = this.fileListLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListLampiran = newFileList;
    },
    editList() {
      this.editModal = true;
      this.activeKey = ["0"];
      this.search = "";
      //this.fetchData();
    },
    handleClose() {
      this.editModal = false;
      this.list_process = [];
    },
    handleEditModal() {},
    changeActionItem(item) {
      let cur = item.currency;
      let status = false;
      let jns = false;
      const temp = this.list_process;
      if (
        item.jenis == "am" &&
        (this.selectedData[0] ? this.selectedData[0].jenis : "am") !== "am"
      ) {
        jns = true;
        if (item.dana_sts === false) {
          this.list_process = [];
        }
      } else if (
        item.jenis !== "am" &&
        (this.selectedData[0] ? this.selectedData[0].jenis : "") == "am"
      ) {
        jns = true;
        if (item.dana_sts === false) {
          this.list_process = [];
        }
      }

      if (!jns) {
        for (let index = 0; index < this.selectedData.length; index++) {
          if (cur !== this.selectedData[index].currency) {
            status = false;
            if (cur !== "IDR" && this.selectedData[index].currency !== "IDR") {
              status = false;
            } else {
              status = true;
              if (item.dana_sts === false) {
                this.list_process = [];
              }
              break;
            }
          }
        }
      }

      if (jns) {
        this.displayMessageValue(
          "error-other",
          "The type transaction is not same!"
        );
        setTimeout(
          function () {
            this.list_process = temp;
          }.bind(this),
          100
        );
        return;
      }

      if (status) {
        if (item.dana_sts === false) {
          this.displayMessageValue("error-other", "The Currency is not same!");
          setTimeout(
            function () {
              this.list_process = temp;
            }.bind(this),
            100
          );
          return;
        }
      }

      for (let index = 0; index < this.list_process.length; index++) {
        if (this.list_process[index].key === item.key) {
          let statusDana = false;
          if (item.dana_sts === true) {
            statusDana = false;
          } else {
            statusDana = true;
          }

          this.list_process[index].dana_sts = statusDana;
          for (let i = 0; i < this.basedListprocess.length; i++) {
            if (
              this.basedListprocess[i].number ===
              this.list_process[index].number
            ) {
              this.basedListprocess[i].dana_sts = statusDana;
            }
          }
        }
      }

      this.sortListProcess();
    },
    sortListProcess() {
      this.list_process = this.ArrshortMultiCol(this.list_process, {
        dana_sts: "desc",
        key: "asc",
      });

      this.selectedData = this.basedListprocess.filter(
        (item) => item.dana_sts == true
      );
    },
    fetchData() {
      this.listProcessLoading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "bkk/fetch_bkk_for_edit",
        params: {
          id_bkk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.list_process = response.data.data;
          for (let index = 0; index < this.list_process.length; index++) {
            let status = false;
            if (this.list_process[index].bkk_dtl_id !== null) {
              status = true;
            }
            let col = [
              {
                ...this.list_process[index],
                number: index + 1,
                key: index + 1,
                dana_sts: status,
              },
            ];
            this.list_process[index] = col[0];
          }

          this.tlForm = {
            type: response.data.type_number,
            no_bilyet: response.data.no_bilyet,
            no_cek: response.data.no_cek,
            no_atm: response.data.no_atm,
            typeValue:
              response.data.type_number == "bilyet_giro"
                ? response.data.no_bilyet
                : response.data.type_number == 'no_cek' ? response.data.no_cek : 
                  response.data.type_number == 'auto_debet'? response.data.auto_debet : response.data.no_atm,
            auto_debet: response.data.auto_debet,
            trans_date: moment(response.data.trans_date),
          };

          if (response.data.file_support!=null){
            let typefile = this.fileTypeFromUrl(response.data.file_support);
            console.log(typefile)
            let file = this.dataURLtoFile(typefile+response.data.files, response.data.file_support);
            file.uid= 'vc-upload-1-1';
            file.status= 'done';
            file.exist= true;
            file.url= this.$serviceUrl+response.data.file_support_url;
            this.pushfile = [];
            this.pushfile.push(file);
          }
          // file.uid = "vc-upload-1-1";
          // file.status = "done";
          // file.exist = true;
          // file.url = this.$serviceUrl + res.hdr[0].file_url;
          // this.dataProcessed.information.attachment=[file];
          

          this.basedListprocess = this.list_process;
          this.listProcessLoading = false;

          this.sortListProcess();
        })
        .catch((err) => {
          this.listProcessLoading = false;
          this.displayMessage("error-connection");
        });
    },
    handleCancelEdit() {
      this.editModal = false;
      this.list_process = [];
    },
    onChangeSearch(e) {
      //console.log(e);
      let tempData = this.basedListprocess;
      if (tempData.length > 0) {
        if (this.search) {
          tempData = tempData.filter(
            (obj) =>
              (obj.no &&
                obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.deskripsi &&
                obj.deskripsi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tgl_transaksi &&
                this.moment(obj.tgl_transaksi)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.currency, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_updated &&
                this.formatCurrency(obj.currency, obj.tlc_updated)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
        }
        this.list_process = tempData;
        this.sortListProcess();
      }
    },
    handlePreview(url) {
        window.open(this.$serviceUrl+url, "_blank");
    },
    handlechangegenBKK(val){
      if(val.target.value=='auto_debet'){
        this.tlForm.upload = null;
        this.pushfile = null;
        this.tlForm.trans_date = null;
      }
      this.tlForm.auto_debet = null;
      this.tlForm.no_atm = null;
      this.tlForm.no_bilyet = null;
      this.tlForm.no_cek = null;
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        this.loadingApproval = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "um_close/approval ",
          processData: false,
          data: {
            id_manifest: this.id,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan_closing ? values.catatan_closing : "",
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            this.loadingApproval = false;
            console.log("error : " + err);
          });
      });
    },
    handleViewDoc(item){
      const url = this.$serviceUrl + item.file_path;
      window.open(url, "_blank");
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
  },
};
</script>

<style lang="less" scoped>
.table-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: @padding;
  &-extra {
    display: flex;
    justify-content: space-between;
    gap: @padding;
    width: 500px;
  }
  .title {
    color: @color-secondary;
  }
}
</style>
